import request from '@/utils/request'
import {isEmpty} from "@/utils/tool";

/**
 * 登录日志
 * @param {*} data
 * @returns
 */
export const getLoginLogs = (data) => request({
    method: 'post',
    url: `/logservice/api/login/logs`,
    data: data
})

/**
 * 部政务平台跳转登录日志
 * @param {*} data
 * @returns
 */
export const getGabLoginLogs = (data) => request({
    method: 'post',
    url: `/logservice/api/gab/login/logs`,
    data: data
})

/**
 * 操作日志
 * @param {*} data
 * @returns
 */
export const getOperateLogs = (data) => request({
    method: 'post',
    url: `/logservice/api/operate/logs`,
    data: data
})

/**
 * 在线人数
 * @param {*} data
 * @returns
 */
export const getOnlineUser = (data) => request({
    method: 'post',
    url: `/authorization/api/online/user`,
    data: data
})


/**
 * oAuth（部政务平台登录）
 * @param {*} authCode 显性登录授权码
 * @param {*} ticket 信任传递票据
 * @returns
 */
export const oAuth = (authCode, ticket) => request({
    url: `/authorization/api/auth/gabLogin`,
    method: 'get',
    params: { authCode, ticket },
    timeout: 30000
})

/**
 * 部政务平台用户补全注册
 * @param {*} data { registerTicket, password, passwordAgain }
 * @returns
 */
export const gabRegister = (data) => request({
    url: `/authorization/api/auth/gabRegister`,
    method: 'post',
    data,
    timeout: 30000
})

export const oAuth626 = (ticket626) => request({
  url: `/authorization/api/auth/loginUserKey?ticket626=${ticket626}`,
  method: 'get'
})

/**
 * getZxxyInfo
 * @param {*} data
 * @returns
 */
 export const getZxxyInfo = (data) => request({
    url: `/yzdservice/enterprise/yzddw/getZxxyInfo`,
    method: 'post',
    data
})

/**
 * getDwIdByDwmc
 * @param {*} data
 * @returns
 */
export const getDwIdByDwmc = (data) => request({
  url: `/yzdservice/enterprise/yzddw/getDwIdByDwmc`,
  method: 'post',
  data
})

/**
 * getDwVipRecordList
 * @param {*} data
 * @returns
 */
 export const getDwVipRecordList = (data,dwId) => request({
    url: `/yzdservice/enterprise/nbry/ywgn/getDwVipRecordList${isEmpty(dwId) ? '' : '/' + dwId}`,
    method: 'post',
    data
})

/**
 * getDwVipxx
 * @param {*} data
 * @returns
 */
 export const getDwVipxx = (data) => request({
    url: `/yzdservice/enterprise/nbry/ywgn/getDwVipxx`,
    method: 'post',
    data
})

/**
 * getVipLevels
 * @param {*} data
 * @returns
 */
 export const getVipLevels = () => request({
    url: `/yzdservice/enterprise/nbry/ywgn/getVipxx`,
    method: 'get'
})

/**
 * updDwVipSave
 * @param {*} data
 * @returns
 */
export const updDwVipSave = (dwId,data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/updateDwVip/${dwId}`,
  method: 'put',
  data
})

/**
 * removeDwVip
 * @param {*} data
 * @returns
 */
export const removeDwVip = (dwId,recordId) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/removeDwVip/${dwId}/${recordId}`,
  method: 'delete'
})

/**
 * getUserBfxx
 * @param {*} data
 * @returns
 */
export const getUserBfxx = (loginName) => request({
  url: `/organization/api/userBfxx/${loginName}`,
  method: 'get'
})


/**
 * 查询审批流程实例
 */
export const getSpxxDto = (data) => request({
  url: `/yzdservice/enterprise/yzddw/getSpxxDto`,
  method: 'post',
  data
})


/**
 * 出入库不符预警导出
 */
export const exportYjczCrkbfExcel = (data,level,xzqhId) => request({
  url: `/yzdservice/enterprise/yjcz/exportCrkbfList${isEmpty(level) ? '' : '/' + level}${isEmpty(xzqhId) ? '' : '/' + xzqhId}`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000000
})
/**
 * 超期未报备预警导出
 */
export const exportCqwbbList = (data,level,xzqhId) => request({
  url: `/yzdservice/enterprise/yjcz/exportCqwbbList${isEmpty(level) ? '' : '/' + level}${isEmpty(xzqhId) ? '' : '/' + xzqhId}`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000000
})


/**
 * 已处置仍预警的数据导出
 */
export const exportYczryjExcel = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/getYczDhyjData`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000000
})

/**
 * 购买证获取购销合同和运输证
 */
export const gmzGxhtxxData = (xkzBh) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/gmzGxhtimgAndYszxx/${xkzBh}`,
  method: 'get',
})

/**
 * 运输证获取购销合同
 */
export const yszGxhtxxData = (xkzId) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/yszGxhtimg/${xkzId}`,
  method: 'get',
})

/**
 * 获取辖区库存列表
 */
export const getXqkcxx = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/getXqkcxx`,
  method: 'post',
  data,
  timeout: 1000 * 60 * 2
})

/**
 * 导出辖区库存信息
 */
export const exportXqkcxx = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/exportXqkcxx`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000 * 60 * 2
})

/**
 * 获取辖区出入库总量
 */
export const getCrkYwzl = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/getCrkYwzl`,
  method: 'post',
  data,
  timeout: 1000 * 60 * 2
})

/**
 * 导出辖区出入库总量
 */
export const exportCrkYwzl = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/exportCrkYwzl`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000 * 60 * 2
})

/**
 * 删除已入网的单位及其用户
 * @param {*} data
 * @returns
 */
export const removeDwxxByGly = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/removeDwxx`,
  method: 'post',
  data
})

/**
 * 系统变更出入库-获取出入库可变更数据的详情
 * @param {*} data
 * @returns
 */
export const getSysCrkBgjlXgxx = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/getCrkBgjlXgxx`,
  method: 'post',
  data
})

export function deobfuscateKey(val) {
    // // 先Base64编码
    // const base64Str = btoa(unescape(encodeURIComponent(val)));
    // // 每个字符ASCII码+1（位移量可自定义）
    // return base64Str.split('').map(char => String.fromCharCode(char.charCodeAt(0) + 1)).join('');


    // 每个字符ASCII码-1（对应混淆的位移）
    const base64Str = val.split('').map(char => String.fromCharCode(char.charCodeAt(0) - 1)).join('');
    // Base64解码
    return decodeURIComponent(escape(atob(base64Str)));
}

/**
 * 系统变更出入库-保存变更
 * @param {*} data
 * @returns
 */
export const saveSysCrkBgjl = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/saveCrkBgjl`,
  method: 'post',
  data
})


/**
 * 获取购买证和运输证相关信息
 * @param {*} data
 * @returns
 */
export const getGmzAndYszxx = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/getGmzAndYszxx`,
  method: 'post',
  data
})

/**
 * 获取单位化学品信息及涉及许可证数量查询
 * @param {*} data
 * @returns
 */
export const getDwhxpAndXkzsl = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/getDwhxpAndXkzsl`,
  method: 'post',
  data,
  timeout: 1000000
})

/**
 * 导出单位化学品信息及涉及许可证数量查询
 */
export const exportDwhxpAndXkzslExcel = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/exportDwhxpAndXkzsl`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000000
})

/**
 * 获取易制毒化学品大类(id-mc)
 */
export const getHxpListByLevel3 = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/getHxpListByLevel3`,
  method: 'get',
})

/**
 * 获取预警相关证书信息
 */
export const getYjczXgzjxx = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/getYjczXgzjxx`,
  method: 'post',
  data,
  timeout: 1000000
})

/**
 * 导出预警相关证书信息
 */
export const exportYjczXgzjxx = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/exportYjczXgzjxx`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000000
})

/**
 * 获取购买证核查获取相关信息
 * @param {*} data
 * @returns
 */
export const getHcGmzxxByXkzBh = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/getHcGmzxxByXkzBh`,
  method: 'post',
  data
})

export function getSystempart(){
    //getcommonpart
    return [
        77,
        73,
        73,
        66,
        73,
        106,
        65,
        78,
        66,
        103,
        107,
        113,
        104,
        107,
        105,
        71,
        57,
        119,
        48,
        66,
        65,
        81,
        69,
        70,
        65,
        65,
        79,
        67,
        65,
        81,
        56,
        65,
        77,
        73,
        73,
        66,
        67,
        103,
        75,
        67,
        65,
        81,
        69,
        65,
        107,
        57,
        56,
        81,
        73,
        66,
        106,
        53,
        83,
        65,
        79,
        76,
        107,
        68,
        84,
        51,
        106,
        119,
        119,
        119,
        79,
        50,
        118,
        103,
        90,
        84,
        89,
        115,
        116,
        122,
        90,
        86,
        65,
        82,
        80,
        122,
        76,
        120,
        51,
        86,
        103,
        85,
        68,
        100,
        101,
        50,
        78,
        84,
        113,
        54,
        77,
        49,
        49,
        69,
        69,
        72,
        80,
        74,
        56,
        117,
        119,
        43,
        114,
        113,
        81,
        98,
        50,
        55,
        89,
        114,
        98,
        57,
        99,
        48,
        72,
        76
    ]
}

export function binaryToString(binary) {
    if (!(binary instanceof Uint8Array)) {
        throw new Error('请传入 Uint8Array 类型的二进制数组');
    }
    let str = '';
    for (let i = 0; i < binary.length; i++) {
        // 将字节值转换为对应的字符
        str += String.fromCharCode(binary[i]);
    }
    return str;
}

/**
 * 客服保存购买证核查结果
 * @param data
 * @returns {*}
 */
export const saveGmzHcxx = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/saveGmzHcxx`,
  method: 'post',
  data
})


/**
 * 获取预警信息列表数据
 * @param {*} data
 * @returns
 */
export const getSysYjxxList = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/getYjxx`,
  method: 'post',
  data,
  timeout: 1000000
})

/**
 * 导出预警信息列表数据
 */
export const exportSysYjxxList = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/exportYjxx`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000000
})

// 验证验证码
export function checkValidTxjym(data) {
    return request({
        method: "post",
        url: "/organization/api/user/checkVaildTyjym",
        data: data
    })
}

/**
 * 客服-出口核查列表
 * @param {*} data
 * @returns
 */
export const kfckhcList = (data) => request({
    url: `/yzdservice/enterprise/nbry/ywgn/getCkhcList`,
    method: 'post',
    data
})

/**
 * 客服-出口核查导出
 * @param {*} data
 * @returns
 */
export const kfckhcExport = (data) => request({
    url: `/yzdservice/enterprise/nbry/ywgn/exportCkhcList`,
    method: 'post',
    responseType: 'blob',
    data,
    timeout: 1000 * 60 * 2
})

/**
 * 客服-出口核查详情
 * @param {*} data
 * @returns
 */
export const kfckhcDetail = (id) => request({
    url: `/yzdservice/enterprise/nbry/ywgn/detailCkhc/`+id,
    method: 'get'
})

/**
 * 客服-进口核查列表
 * @param {*} data
 * @returns
 */
export const kfjkhcList = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/getJkhcList`,
  method: 'post',
  data
})

/**
 * 客服-进口核查导出
 * @param {*} data
 * @returns
 */
export const kfjkhcExport = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/exportJkhcList`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000 * 60 * 2
})

/**
 * 客服-进口核查详情
 * @param {*} data
 * @returns
 */
export const kfjkhcDetail = (id) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/getJkhcDetail/`+id,
  method: 'get'
})
